import _typeof from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.filter.js";
/**
 * Salary storage setting tree helpers.
 *
 * API shape (getPayrollSettingExcelItems):
 *   resp.data.items = {
 *     someGroupKey: {
 *       column: 'basic_information',
 *       txt: '基本信息',
 *       sort: 0,
 *       is_selected: 1,
 *       columns: [
 *         { column: 'staff_code', txt: '工号', sort: 0, is_selected: 1 },
 *         ...
 *       ]
 *     },
 *     ...
 *   }
 *
 * Storage回显 (getStorageSalaryItem):
 *   resp.data.item_keys = ['salary_day', 'salary_basic', ...] (leaf columns only)
 */

/**
 * Convert API `items` object into an `el-tree` compatible tree.
 * @param {Object} items
 * @returns {{ treeData: Array, leafColumnKeys: Array<string> }}
 */
export function buildTreeFromItemsResponse(items) {
  if (!items || _typeof(items) !== 'object') {
    return {
      treeData: [],
      leafColumnKeys: []
    };
  }
  var treeData = [];
  var leafColumnKeys = [];
  Object.keys(items).forEach(function (key) {
    var _group$sort;
    var group = items[key] || {};
    var groupColumn = group.column;
    var groupTxt = group.txt;
    var childrenRaw = Array.isArray(group.columns) ? group.columns : [];
    var children = childrenRaw.slice().sort(function (a, b) {
      var _a$sort, _b$sort;
      return ((_a$sort = a.sort) !== null && _a$sort !== void 0 ? _a$sort : 0) - ((_b$sort = b.sort) !== null && _b$sort !== void 0 ? _b$sort : 0);
    }).map(function (leaf) {
      var _leaf$sort;
      var leafColumn = leaf.column;
      var leafTxt = leaf.txt;
      leafColumnKeys.push(leafColumn);
      return {
        column: leafColumn,
        txt: leafTxt,
        disabled: leaf.column === 'staff_name' || leaf.column === 'total_net_pay',
        sort: (_leaf$sort = leaf.sort) !== null && _leaf$sort !== void 0 ? _leaf$sort : 0
      };
    });
    treeData.push({
      column: groupColumn,
      txt: groupTxt,
      sort: (_group$sort = group.sort) !== null && _group$sort !== void 0 ? _group$sort : 0,
      disabled: groupColumn === 'payroll_total_net_pay',
      // el-tree children
      children: children
    });
  });
  treeData.sort(function (a, b) {
    var _a$sort2, _b$sort2;
    return ((_a$sort2 = a.sort) !== null && _a$sort2 !== void 0 ? _a$sort2 : 0) - ((_b$sort2 = b.sort) !== null && _b$sort2 !== void 0 ? _b$sort2 : 0);
  });
  return {
    treeData: treeData,
    leafColumnKeys: leafColumnKeys
  };
}

/**
 * Build backend payload for setStorageSalaryItem.
 * Backend expects: { sub_project_id: relationId, item_keys: [...] }
 * @param {string|number} relationId
 * @param {Array<string>} leafKeys
 */
export function buildSavePayload(relationId, leafKeys) {
  return {
    sub_project_id: relationId,
    item_keys: Array.isArray(leafKeys) ? leafKeys : []
  };
}

/**
 * Filter checked keys to keep only leaf keys.
 * @param {Array<string>} checkedKeys
 * @param {Set<string>} leafKeySet
 * @returns {Array<string>}
 */
export function filterLeafKeys(checkedKeys, leafKeySet) {
  if (!Array.isArray(checkedKeys) || !leafKeySet) return [];
  return checkedKeys.filter(function (k) {
    return leafKeySet.has(k);
  });
}